<template>
  <div v-if="isVisible" class="modal_overlay" :class="{ fullscreen_mobile: fullscreenMobile }" @click.self="closeModal">
    <div class="modal_container">
      <div v-if="title" class="title">
        <h6 class="mb-0">{{ title }}</h6>
        <PrimaryButton v-if="!forced" class="close grey" @click="closeModal">
          <i class="fa-sharp fa-solid fa-xmark-large"></i>
        </PrimaryButton>
      </div>
      <div class="modal_content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';
import PrimaryButton from './PrimaryButton.vue';

const props = defineProps({
  modelValue: Boolean,
  width: {
    type: String,
    default: '500px',
  },
  title: {
    type: String,
    default: null,
  },
  overflow: {
    type: String,
    default: 'auto',
  },
  forced: {
    type: Boolean,
    default: false
  },
  fullscreenMobile: {
    type: Boolean,
    default: false
  },
});

const emit = defineEmits(['update:modelValue']);

const isVisible = ref(props.modelValue);

watch(() => props.modelValue, (newValue) => {
  isVisible.value = newValue;
});

function closeModal() {
  if(props.forced == false){
    emit('update:modelValue', false);
  }
}
</script>

<style scoped>
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: 20px 0px;
}

.modal_container {
  background-color: #fff;
  position: relative;
  width: 100%;
  max-width: v-bind('width');
  max-height: 100%;
  overflow-y: v-bind('overflow');
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.dark .modal_container {
  background-color: #2e333d;
  color: #cbcfe9;
}

.modal_content {
  background-color: #fff;
  padding: 20px;
  position: relative;
  width: 100%;
  border-radius: 0px 0px 8px 8px;
}

.dark .modal_content {
  background-color: #2e333d;
}

.title {
  padding: 20px;
  z-index: 9999999;
  position: relative;
  border-bottom: 1px #d7d7d7 solid;
  width: inherit;
}

.dark .title {
  border-color: #414556;
}

@media screen and (max-width: 768px) {
  .fullscreen_mobile {
    padding: 0;
  }

  .fullscreen_mobile .modal_container {
    height: 100%;
    max-width: 100%;
    border-radius: 0;
  }

  .fullscreen_mobile .modal_content {
    border-radius: 0;
  }

  .fullscreen_mobile .title {
    position: sticky;
    top: 0;
    background-color: #fff;
  }

  .dark .fullscreen_mobile .title {
    background-color: #2e333d;
  }
}

#app .close {
  position: absolute;
  top: 14px;
  right: 10px;
  padding: 6px 12px !important;
}

.dark .close {
  background-color: #2e333d;
  color: #cbcfe9;
}

.dark .close:hover {
  background-color: #3c434f;
}
</style>
